import React from 'react';
export function BonusSection() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const bonos = [{
    num: '01',
    titulo: 'Libro para Colorear Educativo',
    desc: 'Desarrolla su creatividad y coordinación mientras pinta.',
    img: 'https://cdn.magicpatterns.com/uploads/6VDSjxTZ1a1pKUm6vpA6RK/ChatGPT_Image_15_mar_2026,_09_39_30_p.m..png',
    alt: 'Libro para Colorear Educativo'
  }, {
    num: '02',
    titulo: 'Rutinas y Hábitos para Niños',
    desc: 'Ayuda a tu hijo a aprender hábitos y rutinas diarias de forma simple y entretenida.',
    img: 'https://cdn.magicpatterns.com/uploads/kA1WAQumkrYeXX4LhqbhmX/ChatGPT_Image_15_mar_2026,_09_38_09_p.m..png',
    alt: 'Guía para Padres'
  }, {
    num: '03',
    titulo: 'Calendario de Estimulación de 30 Días',
    desc: 'Ayuda a estimular su desarrollo con actividades simples para hacer cada día mientras se divierte.',
    img: 'https://cdn.magicpatterns.com/uploads/1HRmz1GnrdWpt6Kq7Ue4gb/ChatGPT_Image_15_mar_2026,_09_36_36_p.m..png',
    alt: 'Pack de Juegos Sensoriales'
  }];
  return <section className="py-10 md:py-14 px-4 bg-[#0b1d3a] relative overflow-hidden" data-id="element-42">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(59,130,246,0.08),transparent_60%)] pointer-events-none" data-id="element-43"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-44">
        {/* Header */}
        <div className="text-center mb-8" data-id="element-45">
          <p className="text-blue-400 text-sm font-semibold uppercase tracking-[0.2em] mb-2" data-id="element-46">
            Incluidos con tu compra
          </p>
          <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-3" data-id="element-47">
            Bonos Exclusivos
          </h2>
          <div className="inline-flex items-center gap-2 bg-amber-400 text-gray-900 font-extrabold text-lg md:text-xl px-6 py-2.5 rounded-xl" data-id="element-48">
            <span data-id="element-49">🎁</span>
            <span data-id="element-50">¡GRATIS POR HOY!</span>
          </div>
        </div>

        {/* Cards */}
        <div className="space-y-5" data-id="element-51">
          {bonos.map((bono, i) => <div key={bono.num} className={`flex flex-col ${i === 1 ? 'md:flex-row-reverse' : 'md:flex-row'} items-center gap-5 md:gap-8 bg-white rounded-2xl p-5 md:p-6 shadow-xl`} data-id="element-52">
              {/* Text */}
              <div className="w-full md:w-1/2 text-center md:text-left" data-id="element-53">
                <div className="mb-2 flex items-center justify-center md:justify-start gap-2" data-id="element-54">
                  <span className="text-sm text-gray-400 line-through font-bold" data-id="element-55">
                    $10.000
                  </span>
                  <span className="bg-yellow-400 text-gray-900 font-bold px-3 py-1 rounded-full text-xs uppercase tracking-wider" data-id="element-56">
                    🎁 GRATIS HOY
                  </span>
                </div>

                <h3 className="text-xl md:text-2xl font-extrabold text-gray-900 mb-1 leading-snug" data-id="element-57">
                  <span className="text-blue-600" data-id="element-58">Bono {i + 1}</span> —{' '}
                  {bono.titulo}
                </h3>

                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-59">
                  {bono.desc}
                </p>
              </div>

              {/* Image */}
              <div className="w-full md:w-1/2 cursor-pointer group" onClick={scrollToCompra} data-id="element-60">
                <div className="aspect-square rounded-xl overflow-hidden shadow-lg" data-id="element-61">
                  <img src={bono.img} alt={bono.alt} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-62" />
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}